import { render, staticRenderFns } from "./GuestInvitationOptions.vue?vue&type=template&id=545f7b1a&"
import script from "./GuestInvitationOptions.vue?vue&type=script&lang=ts&"
export * from "./GuestInvitationOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports